module.exports = __webpack_public_path__ + "resources/img/img_credit_event1_v2.21d261a25b0a9806e10d1c069f0f5223.png";